<template>
<div class="about">
    <e-header/>
    <e-body1/>
    <e-body2/>
    <e-body3/>
    <e-footer/>
  </div>
</template>

<script>
import EHeader from "../components/e-header.vue";
import EFooter from "../components/e-footer.vue";
import EBody1 from "../components/curriculum/e-body1.vue";
import EBody2 from "../components/curriculum/e-body2.vue";
import EBody3 from "../components/curriculum/e-body3.vue";
export default {
  components:{
    EBody3, EBody2, EBody1,
    EHeader,EFooter
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>

<style scoped lang="less">

.about{
  width: 100%;
  .body{
    display: flex;
    flex-direction: column;
    .bg{
      width: 100%;
      object-fit: cover;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/curriculum.vue